export const WHITELIST_PROVIDER = [''];

export const WHITELIST_LOGIN = ['Login', 'PublicSurvey'];
